import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Moment} from 'moment-timezone';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {isDefined} from '../../../../commons/commons';
import {YearSummaryConsolidation} from '../../../../shared/ec-economics';

export enum DATE_SELECTION {
    MONTH = 'month',
    YEAR = 'year',
}

export enum CONTENT_DIALOG {
    GSE = 'gse',
    YEARLY = 'yearly',
    MONTHLY = 'monthly'
}

const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MMMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-ec-select-date',
    templateUrl: './ec-select-date.component.html',
    styleUrls: ['./ec-select-date.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS}
    ]
})
export class EcSelectDateComponent implements OnInit, OnDestroy {
    private destroyed = new Subject<void>();

    @Input() summaryConsolidations: YearSummaryConsolidation[];
    @Input() minDate: Moment;
    @Input() maxDate: Moment;
    @Input() dateSelection: DATE_SELECTION;
    @Input() content: CONTENT_DIALOG;
    @Output() values: EventEmitter<Moment> = new EventEmitter<Moment>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    dateForm: FormGroup;

    readonly CONTENT_DIALOG = CONTENT_DIALOG;
    readonly DATE_SELECTION = DATE_SELECTION;
    readonly dateFilter = (date: Moment) => this.selectableDates(date);

    constructor(private fb: FormBuilder) {
        this.dateForm = this.fb.group({selectedDate: new FormControl(null, [Validators.required])});
    }

    ngOnInit() {
        this.dateSelection = isDefined(this.dateSelection) ? this.dateSelection : DATE_SELECTION.MONTH;
        this.updateDateInputFormat();
        this.dateForm.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(value => this.values.emit(value.selectedDate as Moment));
        this.dateForm.statusChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.valid.emit(this.dateForm.valid));
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    onSetDate($event: Moment) {
        this.dateForm.controls.selectedDate.setValue($event);
    }

    private selectableDates(date: Moment) {
        if (date) {
            const year = date.year();
            const month = date.month();
            return this.summaryConsolidations.some(summary => {
                if (this.dateSelection === DATE_SELECTION.MONTH) {
                    return summary.year === year && summary.month === month;
                } else {
                    return summary.year === year;
                }
            });
        }
    }

    private updateDateInputFormat() {
        if (this.dateSelection === DATE_SELECTION.MONTH) {
            CUSTOM_DATE_FORMATS.display.dateInput = 'MMMM YYYY';
        } else if (this.dateSelection === DATE_SELECTION.YEAR) {
            CUSTOM_DATE_FORMATS.display.dateInput = 'YYYY';
        }
    }
}


